import { render, staticRenderFns } from "./WoAction.vue?vue&type=template&id=65f3b512&scoped=true&"
import script from "./WoAction.vue?vue&type=script&lang=ts&"
export * from "./WoAction.vue?vue&type=script&lang=ts&"
import style0 from "./WoAction.vue?vue&type=style&index=0&id=65f3b512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3b512",
  null
  
)

export default component.exports